import { HttpErrorResponse } from '@angular/common/http'
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { MessageService } from 'primeng/api'
import { combineLatest } from 'rxjs'
import { environment } from '../../../../environments/environment'
import { LicenseRespose, SamlLoginRespose } from '../../../api/models'
import { AppSettingService, AuthService } from '../../../api/services'
import { UserPracticesService } from '../../../api/services/user-practices.service'
import { CareFinitySession } from '../../services/CareFinitySession'

@Component({
  selector: 'app-login',
  templateUrl: './app.login.component.html',
  styleUrls: ['./app.login.component.css'],
})
export class AppLoginComponent implements OnInit {

  practice: { label: string; value: string }
  loginForm: UntypedFormGroup
  isInvalidCredentials: boolean
  products: any[]
  licenseCheckSuccessfulWithWarning: boolean
  error = false
  isAlreadyLoggedInPopUp: boolean = false

  private samlLoginRespose: SamlLoginRespose
  private samlLogin: boolean
  isAlreadyLoggedInPopUpWithoutOptionToEnd: boolean

  loginhButtonDisabled: boolean = true

    copyrightDate: string = environment.copyrightDate;
    version: string = environment.version;
    @ViewChild('usernameInput') usernameInput!: ElementRef;
    isPasswordVisible: boolean = false;

    isCustomLogo: boolean = false;
    customLogoName: string = '';

    imageLogoPath: string = '../../../../assets/imagesNew/'; // White_logo_middle.png'
  constructor(
    private messageService: MessageService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: UntypedFormBuilder,
    private userPracticesService: UserPracticesService,
    private authService: AuthService,
    private appSetting: AppSettingService,

     
  ) {
    this.loginForm = this.fb.group({
      userName: ['', Validators.required],
      password: ['', Validators.required],
    })

      this.version = environment.version;
    const licenseCheck: LicenseRespose =
      this.activatedRoute.snapshot.data.licenseCheck

    if (
      this.activatedRoute.snapshot.data.licenseCheck instanceof
      HttpErrorResponse
    ) {
      this.error = true
      return
    }

    if (licenseCheck.status === 'UnderConstruction') {
      this.router.navigate(['underConstruction'])
    } else if (licenseCheck.status == 'Success')
    {

        if (licenseCheck.isCustomLogo)
        {
            this.isCustomLogo = licenseCheck.isCustomLogo;

            if (this.isValidString(licenseCheck.customLogoName))
            {
                this.customLogoName = licenseCheck.customLogoName;
                this.imageLogoPath = this.imageLogoPath + this.customLogoName;
            }
            else
            {
                this.imageLogoPath = this.imageLogoPath + "White_logo_middle.png";
            }

            localStorage.setItem('showMedTechLogo', JSON.stringify(this.isCustomLogo));
        }
       
       
        this.copyrightDate = environment.copyrightDate;  // licenseCheck.copyrightdate;
        localStorage.setItem('copyrightDate', this.copyrightDate);

        this.version = environment.version;
        localStorage.setItem('version', this.version);

    }
    else if (licenseCheck.status == 'Warning') {
      this.licenseCheckSuccessfulWithWarning = true
    } else if (licenseCheck.status) {
      this.router.navigate(['register'])
    } else {
      console.log(licenseCheck)
      this.error = true
      return
    }
  }
    ngOnInit(): void {
        localStorage.clear();
        sessionStorage.clear();
        this.autoFocusAndScroll();
    }

    autoFocusAndScroll(): void {
        if (window.innerWidth <= 768) { // Check for mobile screen width
            // Use setTimeout to ensure the element is rendered before accessing it
            setTimeout(() => {
                this.usernameInput.nativeElement.focus();
                this.usernameInput.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 0);
        }
    }
  tempToken = ''
  onLogin(): void {
    this.isInvalidCredentials = false
    this.authService
      .authToken({
        body: { clientID: environment.clientId, ...this.loginForm.value },
      })
      .subscribe({
        next: (result) => {
          const authResult = result

          if (authResult.status === 'AlreadyLoggedIn') {
            this.tempToken = authResult.token
            this.isAlreadyLoggedInPopUp = true
            return
          } else if (
            authResult.status === 'AlreadyLoggedInButMultipleSessionsNotAllowed'
          ) {
            this.isAlreadyLoggedInPopUpWithoutOptionToEnd = true
            return
          }

          CareFinitySession.login(authResult)

          if (authResult.userId === -100) {
            this.userPracticesService
              .userPracticesGetAllPracticesOfUser()
              .subscribe({
                next: (practices) => {
                  localStorage.setItem(
                    'user_practices',
                    JSON.stringify(practices),
                  )
                  localStorage.setItem('PracticeId', practices[0].practiceid)

                  this.router.navigate(['select-practice'])
                  return
                },
                error: (err) => {
                  console.error('Error fetching user practices', err)
                },
              })
          }

          if (authResult.mfa) {
            this.router.navigate(['mfa'])
            return
          }

          combineLatest([
            this.userPracticesService.userPracticesGetAllPracticesOfUser(),
            this.authService.authAreAllQuestionsAnswered$Response(),
          ]).subscribe({
            next: ([practices, questionAnswered]) => {
              localStorage.setItem('user_practices', JSON.stringify(practices))
              if (questionAnswered.body < 3) {
                this.router.navigate(['Patient/answer_questions'])
                return
              } else if (
                authResult.forcePasswordChange
              ) {
                this.router.navigate(['force-reset-password'], {
                  state: {},
                  queryParams: { u_Name: authResult.userName },
                })
                return
              }

              this.router.navigate(['select-practice'])
            },
            error: (err) => {
              console.error(
                'Error fetching user practices or question status',
                err,
              )
            },
          })
        },
        error: (err) => {
          this.isInvalidCredentials = true
          console.error('Error during login', err)
        },
      })
  }
  endSession() {
    CareFinitySession.updateToken(this.tempToken)
    this.isAlreadyLoggedInPopUp = false
    this.authService.authEndOtherSesssions().subscribe({
      next: (result) => {
        this.onLogin()
      },
      error: (err) => {
        console.error('Error during login', err)
      },
    })
  }

  onForgot() {
    this.router.navigate(['Patient/Forgot-Password'], {
      queryParams: { u_Name: this.loginForm.get('userName').value },
    })
  }

  navigateToDashboard(practiceId: string) {
    this.userPracticesService
      .userPracticesFetchSettings({ practiceId: practiceId })
      .subscribe((data) => {
        this.appSetting.appSettingGetPracticeSettings$Response().subscribe({
          next: (settings) => {
            var ps = settings.body
            CareFinitySession.selectPractice(data[0], ps)

            if (this.samlLogin) {
              if (this.samlLoginRespose?.patientContext) {
                sessionStorage.setItem(
                  'ptId',
                  this.samlLoginRespose?.patientContext.patientId,
                )
                this.router.navigate(['Patient', 'dashboard'])
              } else {
                this.router.navigate(['patient', 'patient-search'])
              }
              return
            }

            if (ps.isArchiveInstance) {
              this.router.navigate(['patient', 'patient-search'])
            } else if (CareFinitySession.user?.roles?.patientSearch) {
              this.router.navigate(['patient', 'patient-search'])
            } else {
              this.router.navigate(['appointment', 'list'])
            }
          },
          error: (err) => {
            console.error(err)
          },
        })
      })
  }

  checkLoginhButtonState() {
    if (this.loginForm.get('userName').value != '') {
      this.loginhButtonDisabled = false
    } else {
      this.loginhButtonDisabled = true
    }
    }

    togglePasswordVisibility(): void {
        this.isPasswordVisible = !this.isPasswordVisible;
    }


    isValidString(value: string | null | undefined): boolean {
        return !!value && value.trim().length > 0;
    }
}
